import { LoadingState } from "@app/root-store/api-result.state";
import { createReducer, on } from "@ngrx/store";
import { DealerBrandingActions } from "../actions";
import { DealerBrandingState, initialDealerBrandingImageListState, initialDealerBrandingState } from "../dealer-branding.state";

export const dealerBrandingReducer = createReducer(
    initialDealerBrandingState,
    on(
        DealerBrandingActions.loadSet.request,
        DealerBrandingActions.loadSingle.request,
        DealerBrandingActions.createSet.request,
        DealerBrandingActions.LoadDealerBrandingImageActions.request,
        (state): DealerBrandingState => ({
            ...state,
            dealerBrandingImages: {
                ...state.dealerBrandingImages,
                callState: LoadingState.loading,
            },
        })
    ),
    on(
        DealerBrandingActions.createSet.success,
        (state, { dealerBranding }): DealerBrandingState => ({
            ...state,
            dealerBrandingImages: {
                ...state.dealerBrandingImages,
                result: {
                    ...state.dealerBrandingImages.result,
                    [dealerBranding.key]: dealerBranding,
                },
                callState: LoadingState.loaded,
            },
        })
    ),
    on(
        DealerBrandingActions.loadSingle.success,
        DealerBrandingActions.LoadDealerBrandingImageActions.success,
        (state, { dealerBranding }) => {
            const key = dealerBranding?.key;

            const dbImage = {
                ...state.dealerBrandingImages.result,
                [key]: dealerBranding,
            };
            return key
                ? {
                      ...state,
                      dealerBrandingImages: { result: dbImage, callState: LoadingState.loaded },
                  }
                : { ...state };
        }
    ), //TODO: replace with loadSet + clareDbCollection object
    on(DealerBrandingActions.clearDealerBrandingState, _ => initialDealerBrandingState),
    on(
        DealerBrandingActions.clearDealerBrandingImageListState,
        (state): DealerBrandingState => ({
            ...state,
            dealerBrandingImageList: initialDealerBrandingImageListState,
        })
    ),
    on(
        DealerBrandingActions.LoadDealerBrandingImageListActions.request,
        (state): DealerBrandingState => ({
            ...state,
            dealerBrandingImageList: {
                ...state.dealerBrandingImageList,
                callState: LoadingState.loading,
                error: null,
            },
        })
    ),
    on(
        DealerBrandingActions.LoadDealerBrandingImageListActions.failure,
        (state, action): DealerBrandingState => ({
            ...state,
            dealerBrandingImageList: {
                ...state.dealerBrandingImageList,
                callState: LoadingState.error,
                error: action.error || null,
            },
        })
    ),
    on(
        DealerBrandingActions.DeleteDealerBrandingImageActions.failure,
        (state, action): DealerBrandingState => ({
            ...state,
            dealerBrandingImageList: {
                ...state.dealerBrandingImageList,
                callState: LoadingState.error,
                error: action.error || null,
            },
            dealerBrandingImages: {
                ...state.dealerBrandingImages,
                callState: LoadingState.error,
                error: action.error || null,
            },
        })
    ),
    on(
        DealerBrandingActions.LoadDealerBrandingImageListActions.success,
        (state, action): DealerBrandingState => ({
            ...state,
            dealerBrandingImageList: {
                ...state.dealerBrandingImageList,
                callState: LoadingState.loaded,
                error: null,
                result: action.images || [],
            },
        })
    ),
    on(DealerBrandingActions.DeleteDealerBrandingImageActions.success, (state, { key }): DealerBrandingState => {
        const updatedImageList = state.dealerBrandingImageList.result?.filter(image => image.key !== key) || [];
        const updatedImages = Object.fromEntries(
            Object.entries(state.dealerBrandingImages.result || {}).filter(([existingKey]) => existingKey !== key)
        );

        return {
            ...state,
            dealerBrandingImageList: {
                ...state.dealerBrandingImageList,
                callState: LoadingState.loaded,
                error: null,
                result: updatedImageList,
            },
            dealerBrandingImages: {
                ...state.dealerBrandingImages,
                callState: LoadingState.loaded,
                error: null,
                result: updatedImages,
            },
        };
    }),
    on(
        DealerBrandingActions.LoadDealerBrandingImageActions.failure,
        (state, action): DealerBrandingState => ({
            ...state,
            dealerBrandingImages: {
                ...state.dealerBrandingImages,
                callState: LoadingState.error,
                error: action.error || null,
            },
        })
    )
);
